import imgI from "../../assets/img/our-approach/geoImg1.png";
import imgII from "../../assets/img/our-approach/geoImg2.png";
import imgIII from "../../assets/img/our-approach/geoImg3.png";
import imgIV from "../../assets/img/our-approach/geoImg4.png";

const Geographic = () => {
	return (
		<>
			<section className='bg-white'>
				<div className='max-w-[1440px] w-[90%] mx-auto py-16 space-y-5'>
					<h2 className='md:text-5xl/[69px] text-3xl/10 font-bold'>
						GEOGRAPHIC COVERAGE
					</h2>
					<p>
						Synergy Care Foundation will focus its efforts on regions where
						service gaps are most pronounced. In Maryland, primary operational
						areas include Baltimore (with several neighborhoods designated as
						MUAs), Montgomery County, Prince George’s County, Dorchester County,
						Somerset County, and parts of Allegany and Garrett counties.
						Maryland’s HPSA designations extend to areas such as Allegany,
						Garrett, Washington, Carroll, Cecil, Harford, Frederick, Baltimore,
						and Baltimore City (Maryland Department of Health, 2023). In
						Virginia, services will target communities in Alexandria, Arlington,
						Fairfax,and Richmond, guided by HPSA designations that identify
						shortages in primary care, dental, and mental health services
						(Virginia Department of Health, 2023).In Washington, D.C.,
						interventions will span the entire metropolitan area with an
						emphasis on underserved neighborhoods and wards experiencing
						significant access.
					</p>
					<img
						src={imgI}
						alt='Our Focus'
						className='w-full rounded-[30px] mt-10'
					/>
				</div>
			</section>
			<section className='bg-[#FFFCF7]'>
				<div className='max-w-[1440px] w-[90%] mx-auto py-16 space-y-5'>
					<h2 className='md:text-5xl/[69px] text-3xl/10 font-bold'>
						GOALS AND EXPECTED OUTCOMES
					</h2>
					<p>
						Our vision is to foster a community in which every
						individual—regardless of financial status or social background—has
						unfettered access to healthcare, housing, food, education, and
						economic opportunity. Synergy Care Foundation is committed to
						reducing access gaps and improving service delivery across our focus
						areas. We aim to achieve measurable improvements in healthcare
						referrals and benefits enrollment, increased housing stability
						through secure placements, better employment outcomes via job
						placements and vocational training, and enhanced community
						engagement leading to overall economic empowerment. These outcomes
						will be rigorously monitored to ensure sustained impact.
					</p>
					<img
						src={imgII}
						alt='Our Focus'
						className='w-full rounded-[30px] mt-10'
					/>
				</div>
			</section>
			<section className='bg-[#FAFFF1]'>
				<div className='max-w-[1440px] w-[90%] mx-auto py-16 space-y-5'>
					<h2 className='md:text-5xl/[69px] text-3xl/10 font-bold'>
						IMPLEMENTATION STRATEGY
					</h2>
					<p>
						Our implementation strategy is underpinned by robust partnerships
						and strategic resource allocation. We will collaborate with
						healthcare providers and Tech companies to build comprehensive
						referral networks that include primary care, specialized services,
						mental health support, and telehealth. Coordination with social
						service agencies will streamline the government benefits enrollment
						process, while partnerships with housing authorities and legal aid
						organizations will help secure safe and stable housing for our
						beneficiaries. Workforce development efforts will be supported
						through alliances with local employment centers and vocational
						training institutions. Dedicated teams will manage healthcare
						referrals, social services navigation, housing assistance,
						employment support, and community outreach. Funding will be secured
						through grants and government programs, backed by data-driven
						proposals that highlight critical needs in our target regions.
						Additionally, robust IT and data management systems will be
						implemented to monitor outcomes and evaluate program performance
						against established indicators.
					</p>
					<img
						src={imgIII}
						alt='Our Focus'
						className='w-full rounded-[30px] mt-10'
					/>
				</div>
			</section>
			<section className='bg-white'>
				<div className='max-w-[1440px] w-[90%] mx-auto py-16 space-y-5'>
					<h2 className='md:text-5xl/[69px] text-3xl/10 font-bold'>
						MONITORING, EVALUATION, AND CONTINUOUS IMPROVEMENT
					</h2>
					<p>
						Performance will be continuously monitored through regular surveys,
						focus groups, and real-time data collection. Our evaluation strategy
						includes quarterly and annual reports, ongoing feedback from partner
						organizations, and a structured review process to ensure the
						continued effectiveness of our interventions. Synergy Care
						Foundation is committed to continuous improvement, with a focus on
						measurable outcomes and stakeholder engagement. As HRSA notes,
						“ongoing evaluation and data collection are critical to refining
						service delivery and ensuring optimal outcomes in shortage areas.”
					</p>
					<img
						src={imgIV}
						alt='Our Focus'
						className='w-full rounded-[30px] mt-10'
					/>
				</div>
			</section>
		</>
	);
};
export default Geographic;
